import React, { useEffect } from "react";
import FormHelperText from "components/Form/components/FormHelperText";
import PropTypes from "prop-types";
import FormSubtext from "./FormSubtext";

const TextInput = ({
  id,
  classes,
  name,
  label,
  error,
  register,
  dataTestId,
  ...inputProps
}) => {
  useEffect(() => {
    if (inputProps.defaultValue && inputProps.setValue) {
      inputProps.setValue(name, inputProps.defaultValue);
    }
  }, [name, inputProps]);

  return (
    <>
      <label htmlFor={id ?? name}>
        {label}
        {inputProps.required && (
          <span className="--required">*</span>
        )}
      </label>
      {inputProps.subtext && <FormSubtext text={inputProps.subtext} />}
      <input
        aria-label={label}
        className={`input-text ${classes ?? ""}`}
        data-testid={dataTestId}
        defaultValue={inputProps.defaultValue}
        disabled={inputProps.disabled}
        id={id ?? name}
        placeholder={inputProps.placeholder}
        required={inputProps.required}
        type={inputProps?.type}
        {...register(name)}
      />
      {error && <FormHelperText message={error.message} />}
    </>
  );
};

TextInput.propTypes = {
  // common
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  register: PropTypes.func.isRequired,
  error: PropTypes.shape({ message: PropTypes.string }),

  // specific
  type: PropTypes.string,
  required: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  classes: PropTypes.string,
};

export default TextInput;
